<template>
  <QuestionBase :errors="[...errorsPost, ...serverErrors, ...jsErrors]"
                :question="question"
                :valid="data !== null">
    <InputSelect v-model="data"
                 :args="args"
                 :db="db"
                 :errors-post="errorsPost"
                 :js-errors="jsErrors"
                 :no-save="noSave"
                 :options="childRelationshipOption"
                 :skipped="skipped"
                 @jsErrors="jsErrors=$event"
                 @serverErrors="serverErrors=$event"
                 @skipped="skipped=$event" />
  </QuestionBase>
</template>

<script>
import {questionLoadHelpers} from "../../helpers/questionLoadHelpers";
import {clientPersonOptions} from "../../options/clientPersonOptions";

import QuestionBase from "../../QuestionBase";
import InputSelect from "../../inputs/InputSelect";

export default {
  name: 'RelationshipChild',
  mixins: [
    questionLoadHelpers,
    clientPersonOptions
  ],
  components: {
    InputSelect,
    QuestionBase
  },
  props: {
    value: {
      type: String,
      required: false
    },
    errorsPost: {
      type: Array,
      default: () => {
        return []
      }
    },
    noSave: {
      type: Boolean,
      default: false
    },
    objectId: {
      type: [
        Number,
        String
      ],
      required: false
    },
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input',
            value)
      },
      get() {
        return this.value
      }
    }
  },
  data() {
    return {
      question: {
        title: 'How is this person related to yourself?',
        subTitle: null,
        tip: null
      },
      db: {
        saveLocation: 'client_person',
        saveField: 'relationship_to_client',
        objectId: this.objectId
      },
      args: {
        taggable: false,
        label: null,
        placeholder: 'Please select..',
        skippable: false,
        required: true,
        inputClass: 'field-75'
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>